/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Source_ColInputs */

const en_admin_users_source_col = /** @type {(inputs: Admin_Users_Source_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const zh_admin_users_source_col = /** @type {(inputs: Admin_Users_Source_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Admin_Users_Source_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_source_col = /** @type {((inputs?: Admin_Users_Source_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Source_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_source_col(inputs)
	return zh_admin_users_source_col(inputs)
});
export { admin_users_source_col as "admin.users.source_col" }